module.exports = __webpack_public_path__ + "static/media/right_arrow.cf7b442b.png";